import { List } from 'antd';
import React, { useState } from 'react';
import ReportDoc from '../../../components/ReportDoc/ReportDoc';
import { useNavigate } from 'react-router-dom';


const SalaryReports = (props) => {

    const navigate = useNavigate();
    const [data] = useState([
        {
            id: 1,
            name: 'XM_11(1) - Цалин, хөдөлмөрийн хөлс, шагнал, урамшуулал болон тэдгээртэй адилтгах хөдөлмөр эрхлэлтийн орлогод ногдуулан суутгасан албан татварын мэдээ',
            path: 'sheet1'
        },
        {
            id: 2,
            name: 'Нийгмийн даатгалын тайлан',
            path: 'socialinsurance'
        },
    ]);

    const onPressNode = (p_item) => {
        navigate('/hrsuite/report/salary/' + p_item.path);
    }

    const renderItem = (item) => {
        return (
            <ReportDoc data={item} onClick={onPressNode} />
        );
    }

    return (
        <div style={{ marginTop: 16 }}>
            <List
                grid={{
                    gutter: [0, 16]
                }}
                dataSource={data}
                renderItem={renderItem}
            />
        </div>
    );
}

export default SalaryReports;